const type = 'OPEN_NEW_CARD_CONFIRMATION';

const openNewCardConfirmation = () => ({
  type,
});

export { type };
export default openNewCardConfirmation;
